import { render, staticRenderFns } from "./SignatureSheetTemplates.vue?vue&type=template&id=3c2045b4"
import script from "./SignatureSheetTemplates.vue?vue&type=script&lang=js"
export * from "./SignatureSheetTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports